import { useEffect, useState } from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer
} from 'recharts';
import baseURL from '../../url';

export default function DailyExpenseGraph() {
    const [data, setData] = useState([]);
    const [totalExpense, setTotalExpense] = useState(0);

    useEffect(() => {
        async function getExpenses() {
            try {
                const res = await fetch(`${baseURL}/expensesGet.php`);
                const json = await res.json();

                if (json && Array.isArray(json.expenses)) {
                    const expenses = json.expenses;

                    let total = 0;
                    const grouped = {};

                    expenses.forEach(({ date, amount }) => {
                        const expenseDate = new Date(date);
                        const amountValue = parseFloat(amount || 0);
                        if (!isNaN(expenseDate) && !isNaN(amountValue)) {
                            const key = expenseDate.toISOString().slice(0, 10); // YYYY-MM-DD
                            if (!grouped[key]) {
                                grouped[key] = 0;
                            }
                            grouped[key] += amountValue;
                            total += amountValue;
                        }
                    });

                    // Convert to sorted array of objects
                    const formatted = Object.keys(grouped)
                        .sort()
                        .map((dateStr) => {
                            const dateObj = new Date(dateStr);
                            const formattedDate = dateObj.toLocaleDateString('es-ES', {
                                day: '2-digit',
                                month: 'short'
                            });
                            return {
                                dia: formattedDate,
                                total: grouped[dateStr]
                            };
                        });

                    setData(formatted);
                    setTotalExpense(total);
                } else {
                    setData([]);
                    setTotalExpense(0);
                }
            } catch (error) {
                console.error('Error cargando gastos:', error);
                setData([]);
                setTotalExpense(0);
            }
        }

        getExpenses();
    }, []);

    const formatoNumero = (num) => {
        return Number(num).toLocaleString('es-ES', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    return (
        <div style={{ width: '100%', marginTop: '20px' }}>
            <h3 style={{ textAlign: 'center' }}>📅 Gastos diarios</h3>

            <div style={{ width: '100%', height: 350 }}>
                <ResponsiveContainer>
                    <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="dia" />
                        <YAxis allowDecimals={true} />
                        <Tooltip formatter={(value) => `$ ${formatoNumero(value)}`} />
                        <Line type="monotone" dataKey="total" stroke="#396c62" strokeWidth={3} />
                    </LineChart>
                </ResponsiveContainer>
            </div>

            <h3 style={{ textAlign: 'center', marginTop: '40px' }}>
                📋 Total de gastos: $ {formatoNumero(totalExpense)}
            </h3>
        </div>
    );
}
